module.exports = __webpack_public_path__ + "img/xc_3d_pic.00f39b6f.png";